var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNissanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 836.71,
    viewBox: "0 0 264.58 221.38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.24 5.0558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    transform: "matrix(.52497 0 0 .52497 -170.24 -5.0558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nissan_Badge_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m293.7 227.7c-.4.1-2 .1-2.7.1h-51.6v12h52.5c.4 0 3.5 0 4.1-.1 10.7-1 15.6-9.9 15.6-17.7 0-8-5.1-16.6-14.8-17.5-1.9-.2-3.5-.2-4.2-.2h-34.3c-1.5 0-3.2-.1-3.8-.3-2.7-.7-3.7-3.1-3.7-5.1 0-1.8 1-4.2 3.8-5 .8-.2 1.7-.3 3.6-.3h49.5v-11.8h-50.3c-2.1 0-3.7.1-5 .3-8.6 1.2-14.6 8.1-14.6 16.9 0 7.2 4.5 15.6 14.4 17 1.8.2 4.3.2 5.4.2h33.4c.6 0 2.1 0 2.4.1 3.8.5 5.1 3.3 5.1 5.8 0 2.4-1.5 5-4.8 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m195.9 227.7c-.4.1-2 .1-2.6.1h-51.7v12h52.5c.4 0 3.5 0 4.1-.1 10.7-1 15.6-9.9 15.6-17.7 0-8-5.1-16.6-14.8-17.5-1.9-.2-3.5-.2-4.2-.2h-34.3c-1.5 0-3.2-.1-3.8-.3-2.7-.7-3.7-3.1-3.7-5.1 0-1.8 1-4.2 3.8-5 .8-.2 1.7-.3 3.6-.3h49.5v-11.8h-50.3c-2.1 0-3.7.1-5 .3-8.6 1.2-14.6 8.1-14.6 16.9 0 7.2 4.5 15.6 14.4 17 1.8.2 4.3.2 5.4.2h33.4c.6 0 2.1 0 2.4.1 3.8.5 5.1 3.3 5.1 5.8 0 2.4-1.4 5-4.8 5.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 101.7,
    y: 181.4,
    width: 13,
    height: 58.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73 240.1 73 181.4 60 181.4 60 225.2 16.7 181.4 0 181.4 0 240.1 13 240.1 13 196.1 56.6 240.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "491.1 181.4 491.1 225.2 447.8 181.4 431.1 181.4 431.1 240.1 444.1 240.1 444.1 196.1 487.6 240.1 504 240.1 504 181.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m363.4 181.4-36.6 58.7h15.8l6.5-10.5h42.7l6.5 10.5h15.7l-36.6-58.7zm21.7 37.1h-29.3l14.7-23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m72.3 148.1c26.2-76.5 98.4-127.9 179.8-127.9s153.7 51.4 179.8 127.9l.2.6h57.3v-6.9l-23.8-2.8c-14.7-1.7-17.8-8.2-21.8-16.4l-1-2c-34.4-73.2-109.3-120.6-190.7-120.6-81.5 0-156.3 47.4-190.7 120.8l-1 2c-4 8.2-7.1 14.7-21.8 16.4l-23.8 2.8v6.9h57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m432.1 272.9-.2.6c-26.2 76.5-98.4 127.8-179.8 127.8s-153.7-51.4-179.8-127.9l-.2-.6h-57.2v6.9l23.8 2.8c14.7 1.7 17.8 8.2 21.8 16.4l1 2c34.4 73.4 109.3 120.8 190.7 120.8s156.3-47.4 190.7-120.7l1-2c4-8.2 7.1-14.7 21.8-16.4l23.8-2.8v-6.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNissanLogo);
export default __webpack_public_path__ + "static/media/nissan_logo.5ab1155f1e10e17612a6467227528583.svg";
export { ForwardRef as ReactComponent };